
export class PaperModel
{
    _id: string | undefined;
    createdOn: number | undefined;
    modifiedOn: number | undefined;
    modifiedBy: string | undefined;
    createdBy: string | undefined;
    type: PaperTypes | string | undefined = "";
    isDeleted: boolean | undefined;
    ownerId: string | undefined;
    paperName: string | undefined = "";
    category: string | undefined = "";
    htmlBody: string | undefined;
    locked: isLocked | undefined
    tags: PaperTagModel[] = [];
    tickers: PaperStockModel[] = [];
    privacy: PaperPrivacy | undefined;
    status: PaperStatus | undefined;
    contributors: ContributorModel[] = [];
    publishedPaper: any = {}
    pricing: PaperPricing | undefined;
    paperPrice: number = 0;
    paperType: string | undefined;
    entries: PaperJournalTrading[] = []
    static copyFromSnapShot(destination: PaperModel | undefined, source: any)
    {
        if (!destination)
        {
            destination = new PaperModel()
        }
        if (!destination.hasOwnProperty('htmlBody'))
        {
            destination['htmlBody'] = ''
        }
        if (!source.hasOwnProperty('htmlBody'))
        {
            source['htmlBody'] = ''
        }
        if ((destination.htmlBody?.length == 0 || destination.htmlBody == undefined || destination.htmlBody == '<p><br></p>') && source.htmlBody.length > 0)
        {
            destination.htmlBody = source.htmlBody
        }
        if (destination.paperName)
        {
            destination.paperName = destination.paperName
        } else
        {
            destination.paperName = source.paperName
        }
        destination.category = source.category
        destination.contributors = source.contributors
        destination.createdBy = source.createdBy
        destination.createdOn = source.createdOn
        destination.modifiedOn = source.modifiedOn
        destination.modifiedBy = source.modifiedBy
        destination.locked = source.locked
        destination.isDeleted = source.isDeleted
        destination.ownerId = source.ownerId
        destination.privacy = source.privacy
        destination.status = source.status
        destination.tags = source.tags
        destination.type = source.type;
        destination.paperType = source.paperType;
        destination.entries = source.entries ?? []
        destination.tickers = source.tickers
        destination._id = source._id
        destination.publishedPaper = source.publishedPaper
        destination.pricing = source.pricing;
        destination.paperPrice = source.paperPrice;
        return destination
    }
}

export enum PaperTypes
{
    article = "article",
    blog = "blog",
    journal = "tradingJournal"
}


export class ContributorModel
{
    contributorId: string | undefined;
    contributorName: string | undefined;
    contributorUserName: string | undefined;
    contributorProfilePicture: number | undefined;
    isPinned: boolean | undefined;
    isArchived: boolean | undefined;
    paperId: string | undefined;
    role: ContributorRoles | undefined
}


export enum ContributorRoles
{
    owner = 'owner',
    editior = "editor",
    readonly = "readonly"
}


export enum PaperPrivacy
{
    public = "public",
    private = "private"
}

export enum PaperPricing
{
    free = "free",
    paid = "paid"
}

export enum PaperStatus
{
    draft = "draft",
    published = "published"
}

type isLocked = {
    isLocked: boolean,
    lockerId: ""
}

export class PostPaperEntity
{
    paperId: string | undefined;
    htmlBody: string | undefined;
    title: string | undefined;
}

export class PaperTagModel
{
    _id: string | undefined;
    name: string | undefined;
    createdOn: number | undefined;
    modifiedOn: number | undefined;
    modifiedBy: string | undefined;
    createdBy: string | undefined;
    isDeleted: boolean | undefined;
    ownerId: string | undefined;
}

export class PaperStockModel
{
    symbol: string | undefined;
    type: string | undefined;
    companyName: string | undefined;
    logoUrl: string | undefined;
}

export class PaperJournalTrading
{
    lineItems: LineItems[] = [];
    description: string | undefined;
    isOption: boolean | undefined;
}

export class LineItems
{
    _id: string | undefined;
    profit: number | undefined;
    quantity: number | undefined;
    rate: number | undefined;
    ticker: string | undefined;
    costPrice: number | undefined;
    remaining: number | undefined;
    companyName: string | undefined;
    logoUrl: string | undefined;
    stockType: string | undefined;
    sellPrice: string | undefined;
    createdOn: number | string | undefined
}